import * as barStyles from "../ReactionBar/ReactionBar.css.ts";
import * as styles from "../../../../../design-system/components/ReactionButton/ReactionButton.css.ts";
import { ReactionIcon } from "../../../../../design-system/components/ReactionIcon/ReactionIcon.jsx";

export const ReactionSummary = ({ counts }) => {
  const sum = Object.values(counts).reduce((s, c) => s + c, 0);
  if (!sum) return null;
  return (
    <div className={barStyles.reactionsList}>
      <div className={styles.content}>
        {sum > 0 && <div aria-label={"Reaktionen"}>{sum}</div>}
        <ReactionIcon reaction={"✨"} />
      </div>
    </div>
  );
};
